import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { UserAuthService } from 'app/services/api-service/user-auth-service/user-auth-service';

@Injectable({
  providedIn: 'root',
})
export class WriterAuthGuard implements CanActivate {
  constructor(
    private userAuthService: UserAuthService,
    private router: Router,
  ) {}

  canActivate(): Promise<boolean | UrlTree> {
    return new Promise((resolve, reject) => {
      this.userAuthService.getSession().then((res) => {
        if (
          ((res.tokens?.idToken?.payload['cognito:groups'] ?? []) as string[]).includes(
            'writers',
          ) ||
          ((res.tokens?.idToken?.payload['cognito:groups'] ?? []) as string[]).includes('admins')
        ) {
          resolve(true);
        } else {
          if (res.tokens) {
            resolve(false);
          } else {
            resolve(this.router.parseUrl('/login'));
          }
        }
      });
    });
  }
}
